import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDateTime } from "src/utils/formatting";

const formatBuildDate = (dateString: string | undefined, language?: string): string => {
    if (!dateString || dateString === "dev") {
        return "dev";
    }
    try {
        const date = new Date(dateString);
        return formatDateTime(date, language, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    } catch {
        return dateString;
    }
};

const formatCommitHash = (hash: string | undefined): string => {
    if (!hash || hash === "dev") {
        return "dev";
    }
    return hash.substring(0, 8);
};

export const BuildInfoPopover = () => {
    const theme = useTheme();
    const { i18n } = useTranslation();

    const buildVersion = import.meta.env.VITE_BUILD_VERSION;
    const commitHash = formatCommitHash(import.meta.env.VITE_BUILD_COMMIT_HASH);
    const buildDate = formatBuildDate(import.meta.env.VITE_BUILD_DATE, i18n.language);

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography variant="caption" sx={{ color: theme.custom.grey[1200], fontSize: "11px" }}>
                {buildVersion?.startsWith("v") ?
                    <strong>Version: {buildVersion}</strong>
                :   <>
                        <strong>Build: {commitHash}</strong> @ {buildDate}
                    </>
                }
            </Typography>
        </Box>
    );
};
